import React from 'react';
import { ClerkProvider, useAuth } from '@clerk/clerk-react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './components/MainLayout';
import ClerkErrorBoundary from './components/ClerkErrorBoundary';
import TemplateCreation from './pages/TemplateCreation';
import TemplateLibrary from './pages/TemplateLibrary';
import ConfigurationManagement from './pages/ConfigurationManagement';
import ConversationalBuilder from './pages/ConversationalBuilder';
import NetworkValidation from './pages/NetworkValidation';
import BulkOperations from './pages/BulkOperations';
import AuditCompliance from './pages/AuditCompliance';
import ExportDeploy from './pages/ExportDeploy';
import Analytics from './pages/Analytics';
import './App.css';

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY!;

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function HomePage() {
  const { isSignedIn } = useAuth();
  
  if (isSignedIn) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return <Login />;
}

function App() {
  return (
    <ClerkErrorBoundary>
      <ClerkProvider publishableKey={clerkPubKey}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router>
            <Routes>
            <Route path="/" element={<HomePage />} />
            <Route element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/templates/create" element={<TemplateCreation />} />
              <Route path="/templates/library" element={<TemplateLibrary />} />
              <Route path="/configurations" element={<ConfigurationManagement />} />
              <Route path="/conversational" element={<ConversationalBuilder />} />
              <Route path="/validation" element={<NetworkValidation />} />
              <Route path="/bulk-operations" element={<BulkOperations />} />
              <Route path="/audit" element={<AuditCompliance />} />
              <Route path="/export-deploy" element={<ExportDeploy />} />
              <Route path="/analytics" element={<Analytics />} />
            </Route>
          </Routes>
        </Router>
      </ThemeProvider>
    </ClerkProvider>
    </ClerkErrorBoundary>
  );
}

export default App;
